import { useInfiniteQuery } from 'react-query'
import axios from 'axios'

import { api, handleCommonErrors, useQueryApi } from 'utils/api'
import { getSession } from 'utils/auth'
import { baseUrl } from 'configs/api'

import type { AxiosResponse } from 'axios'
import type { BuktiKaryaResponseData, KaryaSayaList } from 'types/bukti-karya'

interface ParamsUsersBuktiKaryaByCategory {
  cursor?: number
  pageSize?: number
}

interface ResponseSuccessBuktiKaryaInterface {
  data: BuktiKaryaResponseData
  meta: any // TODO: Enrich Meta type
}

interface ResponseSuccessUsersBuktiKaryaByCategory {
  data: KaryaSayaList[]
  meta: {
    limit: number
    cursor: number
  }
}

/**
 * @deprecated Bukti Karya is no longer served from guru-frontend and this is no longer maintained
 */
export function useAPIUsersBuktiKaryaByCategory(
  userId: string,
  category: string,
  params: ParamsUsersBuktiKaryaByCategory = { cursor: 0, pageSize: 6 }
) {
  const apiUrl = `/teachers-career/v1alpha1/bukti-karya/profile/${userId}/categories/${category}`

  return useInfiniteQuery<ResponseSuccessUsersBuktiKaryaByCategory, Error>(
    [apiUrl],
    async ({ pageParam }) => {
      const session = getSession()
      let response

      if (!!session) {
        response = await api<ResponseSuccessUsersBuktiKaryaByCategory>(apiUrl, {
          params: pageParam || params,
        })
      } else {
        try {
          response = (
            await axios.get<
              any,
              AxiosResponse<ResponseSuccessUsersBuktiKaryaByCategory>
            >(`${baseUrl}${apiUrl}`)
          ).data
        } catch (error) {
          handleCommonErrors(error?.response?.status, apiUrl, error.response)
        }
      }
      return response
    },
    {
      enabled: !!userId,
      getNextPageParam({ data, meta }) {
        if (data.length < meta.limit) return

        return {
          cursor: meta.cursor,
          pageSize: params.pageSize,
        }
      },
    }
  )
}

// this is for v2

const basePathV2 = '/teachers-career/v2/bukti-karya'

/**
 * @deprecated Bukti Karya is no longer served from guru-frontend and this is no longer maintained
 */
export function useAPIBuktiKaryaListV2(contentType = 'PDF') {
  return useQueryApi<ResponseSuccessBuktiKaryaInterface>(`${basePathV2}/me`, {
    axiosConfig: {
      params: {
        contentType,
      },
    },
    queryConfig: {
      useErrorBoundary: true,
    },
  })
}
